import React from 'react';

const AboutUs = () => {
    return (
        <div className="container text-center mt-5">
            <h2 > Welcome to <span style={{color:'tomato'}}> Nwzz-TourPacker</span> </h2>
            <h4>This is a Global Tour and Trip Industry. We Have number of package and Plan for world Trip. We provide Experienced Guide with our customers . We provide all kinds of facility from business Class to Economy Class from our Agency. Your Safety and Satisfaction is Our first Priority.   </h4><br /><br /><br />

            <h3>Our Address</h3><br />
            <p> Level-4, 34, Awal Centre, Banani, Dhaka <br />
                Official: web@nwzz-tourPacker.com <br />
                Helpline : 01322810867 (Available : 24 Hours)</p><br /><br /><br />
        </div>
    );
};

export default AboutUs;